import { siteData } from '@/mocks/siteData';

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[900px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <div className="inline-flex items-center gap-2 px-3 py-1 bg-secondary-100 text-secondary-700 rounded-full text-xs font-label mb-3">
            <i className="ri-chat-1-line"></i>吃瓜评论
          </div>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-3">
            吃瓜群众有话说
          </h2>
          <p className="text-sm text-foreground-500 max-w-[500px] mx-auto">
            来自黑料社区的精选热评，看看大家都怎么聊
          </p>
        </div>

        <div className="space-y-4">
          {siteData.comments.map((comment) => (
            <div
              key={comment.id}
              className="bg-background-50 border border-background-200/70 rounded-2xl p-5 md:p-6"
            >
              <div className="flex items-start gap-4">
                <div className="shrink-0 w-10 h-10 rounded-full overflow-hidden bg-background-200">
                  <img
                    src={comment.avatar}
                    alt={comment.username}
                    className="w-full h-full object-cover object-top"
                  />
                </div>

                <div className="flex-1 min-w-0">
                  <div className="flex items-center flex-wrap gap-2 mb-2">
                    <span className="font-label text-sm font-semibold text-foreground-900">
                      {comment.username}
                    </span>
                    {comment.tag && (
                      <span className="text-[10px] px-1.5 py-0.5 rounded bg-accent-100 text-accent-700 font-label">
                        {comment.tag}
                      </span>
                    )}
                    <span className="text-xs text-foreground-400">{comment.date}</span>
                  </div>

                  <p className="text-sm text-foreground-700 leading-relaxed mb-3">
                    {comment.content}
                  </p>

                  <div className="flex items-center gap-4 text-xs text-foreground-400">
                    <button className="flex items-center gap-1 hover:text-primary-600 transition-colors cursor-pointer bg-transparent border-0 p-0">
                      <i className="ri-thumb-up-line"></i>
                      {comment.likes.toLocaleString()}
                    </button>
                    <button className="flex items-center gap-1 hover:text-primary-600 transition-colors cursor-pointer bg-transparent border-0 p-0">
                      <i className="ri-chat-3-line"></i>
                      回复
                    </button>
                    <button className="flex items-center gap-1 hover:text-primary-600 transition-colors cursor-pointer bg-transparent border-0 p-0">
                      <i className="ri-share-forward-line"></i>
                      分享
                    </button>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}